/* eslint-disable import/no-default-export */
// ----------------------------------------------------------------------
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function Typography(theme) {
    return {
        "MuiTypography": {
            "styleOverrides": {
                "gutterBottom": {
                    "marginBottom": theme.spacing(1),
                },
                "paragraph": {
                    "marginBottom": theme.spacing(2),
                },
            },
        },
    };
}
